export default {
  data() {
    return  {
      localizeLife: [
        {
          key: 21,
          value: 'message.lifeCatBehaviourChange'
        },
        {
          key: 10,
          value: 'message.lifeCatCarbsVsFat'
        },
        {
          key: 6,
          value: 'message.lifeCatChildren'
        },
        {
          key: 8,
          value: 'message.lifeCatConditions'
        },
        {
          key: 23,
          value: 'message.lifeCatDairyFree'
        },
        {
          key: 18,
          value: 'message.lifeCatEducation'
        },
        {
          key: 20,
          value: 'message.lifeCatExercise'
        },
        {
          key: 7,
          value: 'message.lifeCatFoodAndRecipes'
        },
        {
          key: 3,
          value: 'message.lifeCatFoodSwaps'
        },
        {
          key: 22,
          value: 'message.lifeCatFoodHCP'
        },
        {
          key: 17,
          value: 'message.lifeCatIntermittentFasting'
        },
        {
          key: 14,
          value: 'message.lifeCatMotivation'
        },
        {
          key: 1,
          value: 'message.lifeCatMythBusting'
        },
        {
          key: 16,
          value: 'message.lifeCatPHC'
        },
        {
          key: 9,
          value: 'message.lifeCatRecipesOfTheWeek'
        },
        {
          key: 12,
          value: 'message.lifeCatResearch'
        },
        {
          key: 15,
          value: 'message.lifeCatSeasonalVeg'
        },
        {
          key: 13,
          value: 'message.lifeCatSuccessStories'
        },
        {
          key: 5,
          value: 'message.lifeCatSugar'
        },
        {
          key: 19,
          value: 'message.lifeCatWereListeningTo'
        },
        {
          key: 11,
          value: 'message.lifeCatWereWatching'
        },
        {
          key: 24,
          value: 'Evidence and Papers'
        },
      ]
    }
  },
  methods: {
    localizeLifeCat(key) {
      let self = this;
      let label = self.localizeLife.filter(function (item) {
        return item.key === key;
      });

      if(label.length === 1) {
        return self.$t(label[0].value);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/Life/index.js